import { render, staticRenderFns } from "./VOfficeFilter.vue?vue&type=template&id=58277e9f&"
import script from "./VOfficeFilter.vue?vue&type=script&lang=js&"
export * from "./VOfficeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports